import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCheck } from "react-icons/fa";
import Header from "./Header";
import Footer from "./Footer";

export default function PageLayout({
  eyebrow,
  title,
  intro,
  sectionTitle,
  sectionIntro,
  cards,
  steps = [],
  children,
}) {
  return (
    <main>
      <Header />

      <section className="page-hero">
        <div className="site-container narrow">
          <span className="eyebrow light">{eyebrow}</span>
          <h1>{title}</h1>
          <p>{intro}</p>
          <div className="hero-actions">
            <Link className="button button-gold" to="/contato">
              Falar com a equipa <FaArrowRight />
            </Link>
            <Link className="text-link" to="/orcamento">
              Pedir orçamento
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="site-container">
          <div className="section-heading page-heading">
            <div>
              <span className="eyebrow">Em detalhe</span>
              <h2>{sectionTitle}</h2>
            </div>
            <p>{sectionIntro}</p>
          </div>

          <div className="card-grid">
            {cards.map((card, index) => (
              <article className="feature-card" key={card.title}>
                <span className="card-index">0{index + 1}</span>
                <h2>{card.title}</h2>
                <p>{card.text}</p>
                {card.points && (
                  <ul className="detail-list">
                    {card.points.map((point) => (
                      <li key={point}>
                        <FaCheck /> {point}
                      </li>
                    ))}
                  </ul>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      {steps.length > 0 && (
        <section className="section process-section">
          <div className="site-container">
            <span className="eyebrow">Como funciona</span>
            <h2 className="process-title">Um percurso simples e acompanhado</h2>
            <div className="process-grid">
              {steps.map((step, index) => (
                <article key={step.title}>
                  <span>{index + 1}</span>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
      )}

      {children}

      <section className="section final-cta">
        <div className="site-container cta-inner">
          <div>
            <span className="eyebrow">Próximo passo</span>
            <h2>Vamos transformar a sua necessidade numa solução concreta.</h2>
            <p>
              A nossa equipa está pronta para orientar, esclarecer e preparar
              uma proposta.
            </p>
          </div>
          <Link className="button button-dark" to="/contato">
            Começar agora <FaArrowRight />
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
